import { makeObservable } from '../../../utils/makeObservable';

export const isGaScriptLoaded = makeObservable<boolean>(false);
